export default __webpack_public_path__ + "static/media/header_bg.8a5af71a.png";